import { ChangeEvent } from 'react';

import { ScriptureData } from 'types';
import actionTypes from 'constants/actionTypes';

import { AddEncumbranceModalContextType } from '../types/AddEncumbranceModalContextType';

export const addEncumbranceModalInitValue: AddEncumbranceModalContextType = {
  data: {
    modalActionType: actionTypes.ADD,
    shareFrom: 0,
    shareTo: 0,
    scriptureData: {
      notaryName: '',
      protocolNr: '',
      notaryCity: '',
    },
    file: undefined,
    from: 0,
    to: 0,
    date: '',
    endDate: '',
    selectedEncumbranceTypeOption: null,
    encumbranceTypeOptions: [],
    hasBeenEdited: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal: () => {},
    handleChangeFile: (file: File | undefined) => {}, // eslint-disable-line no-unused-vars
    handleChangeScriptureData: (scriptureData: ScriptureData) => {}, // eslint-disable-line no-unused-vars
    handleChangeFrom: (value: number) => {}, // eslint-disable-line no-unused-vars
    handleChangeTo: (value: number) => {}, // eslint-disable-line no-unused-vars
    handleChangeDate: (event: ChangeEvent<HTMLInputElement>) => {}, // eslint-disable-line no-unused-vars
    handleChangeEndDate: (event: ChangeEvent<HTMLInputElement>) => {}, // eslint-disable-line no-unused-vars
    handleChangeEncumbranceTypeOption: (option: any) => {}, // eslint-disable-line no-unused-vars
    handleSave: () => {},
  },
};
